import { VariablesService } from './../../../../shared/services/variables/variables.service';
import { Component, OnInit, Input, Inject } from '@angular/core';
import { EventsService } from '../../../../shared/services';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-chat-with-us',
  templateUrl: './chat-with-us.component.html',
  styleUrls: ['./chat-with-us.component.scss']
})
export class ChatWithUsComponent implements OnInit {
  @Input() public whatsposition;
  @Input() public fbposition;
  @Input() public pageName;
  @Input() public html;
  @Input() public config;
  constructor(
    public eventService: EventsService,
    @Inject(DOCUMENT) private document: any,
    public variableService: VariablesService
  ) { }

  ngOnInit() {
  }
  getShareEvents(eventName, sharePosition, action?, event?) {
    const payload = {
      eventName: eventName,
      page_name: this.pageName,
      referrer_page: this.document.referrer,
      info_1: 'position',
      info_2: sharePosition
    };
    this.eventService.sendSystemEvent(payload).subscribe(_ => _);

    this.eventService.userGTMEvents({
      event: 'chat_click',
      event_category: 'navigation',
      event_action: action,
      event_label: `${event.target.innerText}|body`
    });
  }
}
